export default __webpack_public_path__ + "static/media/social-events-tablet@2x.d4aa5403.jpg";